// Роли «служебного» доступа (стафф). Используются для мягкого запуска разделов:
// напр. /bots/trends пока виден только стаффу (гейт по роли, не по ?ref — тот
// URL-параметр не является контролем доступа). Набор совпадает с админ-доступом
// бэка (см. backend deps.py / referral require_admin). Если у конкретного
// админ-аккаунта иная роль — добавить сюда.
const STAFF_ROLES = new Set(['admin', 'superadmin', 'developer'])

/** true — у пользователя стафф-роль (видит WIP-разделы вроде /bots/trends). */
export function isStaff(role?: string | null): boolean {
	return !!role && STAFF_ROLES.has(role)
}
